import script from "./goRinSyo0040.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0040.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0040.vue?vue&type=style&index=0&id=5f44cb80&lang=scss"

const __exports__ = script;

export default __exports__